module.exports = __webpack_public_path__ + "img/47.71696298.png";